import React, { useState, useEffect } from 'react';
import { 
  Form, 
  Input, 
  Button, 
  message, 
  Tabs, 
  Divider, 
  Row, 
  Col, 
  Spin,
  Select,
  Upload,
  Avatar,
  Alert,
  DatePicker
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import api from '../services/api';
import axios from 'axios';
import dayjs from 'dayjs';

const { TabPane } = Tabs;
const { Option } = Select;
const { TextArea } = Input;

const ProfileSettings = () => {
  const [profileForm] = Form.useForm();
  const [passwordForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [childCategories, setChildCategories] = useState([]);
  const [subchildCategories, setSubchildCategories] = useState([]);
  const [isLoadingUserData, setIsLoadingUserData] = useState(true);
  const [userData, setUserData] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [showOtherCategory, setShowOtherCategory] = useState(false);
  const [showOtherSubCategory, setShowOtherSubCategory] = useState(false);
  const [showOtherChildCategory, setShowOtherChildCategory] = useState(false);
  const [identityDocType, setIdentityDocType] = useState('');
  const [statesList, setStatesList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);

  const PROFILE_PHOTO_BASE_URL = 'https://www.businessmateworkflow.in/uploads/profile-photos/';

  // Options for various dropdowns
  const genderOptions = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'transgender', label: 'Transgender' }
  ];

  const businessStatusOptions = [
    { value: 'running', label: 'Running Business' },
    { value: 'new', label: 'New Business' },
    { value: 'partner_replacement', label: 'Partner Replacement' }
  ];

  const timeCommitmentOptions = [
    { value: 'full_time', label: 'Full-time' },
    { value: 'part_time', label: 'Part-time' }
  ];

  const financialCapabilityOptions = [
    { value: '1-5', label: '₹1-5 Lakhs' },
    { value: '5-10', label: '₹5-10 Lakhs' },
    { value: '10-25', label: '₹10-25 Lakhs' },
    { value: '25-50', label: '₹25-50 Lakhs' },
    { value: '50+', label: '₹50+ Lakhs' }
  ];

  const fundingSourceOptions = [
    { value: 'own', label: 'Own Funds' },
    { value: 'loan', label: 'Loan' },
    { value: 'investor', label: 'Investor' }
  ];

  const qualificationOptions = [
    { value: '10th', label: '10th' },
    { value: '12th', label: '12th' },
    { value: 'diploma', label: 'Diploma' },
    { value: 'graduation', label: 'Graduation' },
    { value: 'post_graduation', label: 'Post Graduation' }
  ];

  const businessModelOptions = [
    { value: 'franchise', label: 'Franchise' },
    { value: 'partnership', label: 'Partnership' },
    { value: 'proprietorship', label: 'Proprietorship' },
    { value: 'private_limited', label: 'Private Limited' },
    { value: 'llp', label: 'LLP' }
  ];

  const registrationTypeOptions = [
    { value: 'gst', label: 'GST' },
    { value: 'roc', label: 'ROC' },
    { value: 'msme', label: 'MSME' },
    { value: 'rera', label: 'RERA' },
    { value: 'other', label: 'Other' }
  ];

  const contactModeOptions = [
    { value: 'call', label: 'Call' },
    { value: 'whatsapp', label: 'WhatsApp' },
    { value: 'email', label: 'Email' }
  ];

  const priceOptions = [
    { value: 'negotiable', label: 'Negotiable' },
    { value: 'fixed', label: 'Fixed Price' }
  ];

  const identityDocOptions = [
    { value: 'aadhaar', label: 'Aadhaar' },
    { value: 'pan', label: 'PAN' },
    { value: 'voter_id', label: 'Voter ID' },
    { value: 'passport', label: 'Passport' }
  ];

  const businessTypeOptions = [
    { value: 'Regular Business Partner', label: 'Regular Business Partner' },
    { value: 'Startup', label: 'Startup' },
    { value: 'Franchise', label: 'Franchise' }
  ];

  const priceUnitOptions = [
    { value: 'Thousand', label: 'Thousand' },
    { value: 'Lakh', label: 'Lakh' },
    { value: 'Crore', label: 'Crore' }
  ];

  const customerBaseOptions = [
    { value: 'Customer Base', label: 'Customer Base' },
    { value: 'Client Contracts', label: 'Client Contracts' }
  ];

  const joiningAvailabilityOptions = [
    { value: 'Immediate Joiner', label: 'Immediate Joiner' },
    { value: 'Notice period', label: 'Notice period' }
  ];

  const professionalBackgroundOptions = [
    { value: 'Job', label: 'Job' },
    { value: 'Business', label: 'Business' },
    { value: 'Self-Employed', label: 'Self-Employed' },
    { value: 'Not Working', label: 'Not Working' }
  ];

  const sameAsPermanentOptions = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' }
  ];

  const futureVisionOptions = [
    { value: 'Short-Term', label: 'Short Term' },
    { value: 'Long-Term', label: 'Long Term' }
  ];

  const clearMessages = () => {
    setSuccessMsg('');
    setErrorMsg('');
  };

  const uploadProps = {
    name: 'image',
    action: `${api.defaults.baseURL}/upload`,
    headers: {
      authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    fileList,
    beforeUpload: (file) => {
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        message.error('You can only upload image files!');
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error('Image must be smaller than 2MB!');
        return false;
      }
      return true;
    },
    onChange: (info) => {
      setFileList(info.fileList);
      if (info.file.status === 'uploading') {
        setUploading(true);
        return;
      }
      if (info.file.status === 'done') {
        setUploading(false);
        if (info.file.response && info.file.response.success) {
          message.success('Profile photo uploaded successfully!');
          const newProfilePhoto = info.file.response.filename;
          profileForm.setFieldsValue({
            profile_photo: newProfilePhoto
          });
          setUserData(prev => ({
            ...prev,
            profile_photo: newProfilePhoto
          }));
        } else {
          message.error(info.file.response?.message || 'Upload failed!');
        }
      }
      if (info.file.status === 'error') {
        setUploading(false);
        message.error('Upload failed!');
      }
    },
    onRemove: () => {
      profileForm.setFieldsValue({
        profile_photo: null
      });
      setFileList([]);
      setUserData(prev => ({
        ...prev,
        profile_photo: null
      }));
    },
  };

  // Fetch states on mount
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await axios.get("https://api.countrystatecity.in/v1/countries/IN/states", {
          headers: {
            "X-CSCAPI-KEY": "T3RzWUFuQkd6em1EZHlQTWlwYUxKb2dPWXlrWDBENnVBcTN2clViaQ=="
          }
        });
        setStatesList(response.data);
      } catch (error) {
        console.error("Error fetching states:", error);
        setStatesList([]);
      }
    };
    
    fetchStates();
  }, []);

  const handleStateSelect = async (stateCode, stateName) => {
    profileForm.setFieldsValue({
      state: stateName,
      city: ''
    });
    
    try {
      const response = await axios.get(`https://api.countrystatecity.in/v1/countries/IN/states/${stateCode}/cities`, {
        headers: {
          "X-CSCAPI-KEY": "T3RzWUFuQkd6em1EZHlQTWlwYUxKb2dPWXlrWDBENnVBcTN2clViaQ=="
        }
      });
      setCitiesList(response.data);
    } catch (error) {
      console.error("Error fetching cities:", error);
      setCitiesList([]);
    }
  };

  // Load cities when state is already set
  useEffect(() => {
    if (userData?.state && statesList.length > 0) {
      const stateObj = statesList.find(s => s.name === userData.state);
      if (stateObj) {
        axios.get(`https://api.countrystatecity.in/v1/countries/IN/states/${stateObj.iso2}/cities`, {
          headers: {
            "X-CSCAPI-KEY": "T3RzWUFuQkd6em1EZHlQTWlwYUxKb2dPWXlrWDBENnVBcTN2clViaQ=="
          }
        }).then(res => setCitiesList(res.data))
          .catch(() => setCitiesList([]));
      }
    }
  }, [userData?.state, statesList]);

  // Fetch initial data
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoadingUserData(true);
        clearMessages();
        
        const userResponse = await api.get('/user/about_me');
        const userData = userResponse.data.data;
        setUserData(userData);
        
        // Set identity document type if available
        if (userData.identity_doc_type) {
          setIdentityDocType(userData.identity_doc_type);
        }
        
        // Prepare form values with ALL fields from database
        const formValues = {
          // Common fields
          name: userData.name,
          age: userData.age,
          contact_no: userData.contact_no,
          address: userData.address,
          city: userData.city,
          pincode: userData.pincode,
          state: userData.state,
          profile_photo: userData.profile_photo,
          
          // Category fields
          parent_category_id: userData.parent_category_id,
          child_category_id: userData.child_category_id,
          subchild_category_id: userData.subchild_category_id,
          other_category: userData.other_category,
          other_child_category: userData.other_child_category,
          other_subchild_category: userData.other_subchild_category,
          
          // Identity fields
          identity_doc_type: userData.identity_doc_type,
          identity_number: userData.identity_number,
          
          // 3rd Party Services fields
          years_of_experience: userData.years_of_experience,
          expertise: userData.expertise,
          
          // Partner fields
          gender: userData.gender,
          aadhaar_number: userData.aadhaar_number,
          pan_number: userData.pan_number,
          professional_background: userData.professional_background,
          industry_experience: userData.industry_experience,
          financial_capability: userData.financial_capability,
          funding_source: userData.funding_source,
          skills: userData.skills,
          ownership_preference: userData.ownership_preference,
          time_commitment: userData.time_commitment,
          past_partnership_experience: userData.past_partnership_experience,
          legal_disputes: userData.legal_disputes,
          future_vision: userData.future_vision,
          business_status: userData.business_status,
          business_type: userData.business_type,
          
          // Employee fields
          permanent_address: userData.permanent_address,
          highest_qualification: userData.highest_qualification,
          certificate_details: userData.certificate_details,
          job_skills: userData.job_skills,
          expected_salary: userData.expected_salary,
          joining_availability: userData.joining_availability,
          notice_period_days: userData.notice_period_days,
          emergency_contact_name: userData.emergency_contact_name,
          emergency_contact_relation: userData.emergency_contact_relation,
          emergency_contact_number: userData.emergency_contact_number,
          emergency_contact_address: userData.emergency_contact_address,
          same_as_permanent: userData.same_as_permanent,
          
          // Business fields
          business_name: userData.business_name,
          business_model: userData.business_model,
          established_year: userData.established_year
  ? dayjs(String(userData.established_year), "YYYY")
  : null,
          reason_for_sale: userData.reason_for_sale,
          asking_price: userData.asking_price,
          asking_price_unit: userData.asking_price_unit,
          annual_turnover: userData.annual_turnover,
          annual_turnover_unit: userData.annual_turnover_unit,
          net_profit: userData.net_profit,
          net_profit_unit: userData.net_profit_unit,
          assets_included: userData.assets_included,
          liabilities: userData.liabilities,
          number_of_employees: userData.number_of_employees,
          customer_base: userData.customer_base,
          ongoing_projects: userData.ongoing_projects,
          franchise_validity: userData.franchise_validity,
          business_registration_type: userData.business_registration_type,
          registration_number: userData.registration_number,
          lease_details: userData.lease_details,
          preferred_contact_mode: userData.preferred_contact_mode,
          price_negotiable: userData.price_negotiable
        };
        
        // Check if we need to show "other" fields
        if (userData.parent_category_id === null && userData.other_category) {
          setShowOtherCategory(true);
          formValues.parent_category_id = 'other';
        }
        if (userData.child_category_id === null && userData.other_child_category) {
          setShowOtherChildCategory(true);
          formValues.child_category_id = 'other';
        }
        if (userData.subchild_category_id === null && userData.other_subchild_category) {
          setShowOtherSubCategory(true);
          formValues.subchild_category_id = 'other';
        }
        
        profileForm.setFieldsValue(formValues);
        
        if (userData.profile_photo) {
          setFileList([{
            uid: '-1',
            name: userData.profile_photo,
            status: 'done',
            url: `${PROFILE_PHOTO_BASE_URL}${userData.profile_photo}`,
          }]);
        }
        
        const [catRes, childRes, subchildRes] = await Promise.all([
          api.get('/categories'),
          api.get('/child-categories'),
          api.get('/subchild-categories'),
        ]);
        
        setCategories(catRes.data || []);
        setChildCategories(childRes.data || []);
        setSubchildCategories(subchildRes.data || []);
        
      } catch (error) {
        console.error('Error fetching data:', error);
        setErrorMsg('Failed to load profile data');
      } finally {
        setIsLoadingUserData(false);
      }
    };
    
    fetchData();
    // profileForm is a stable reference from Form.useForm() (antd guarantees
    // referential stability), so including it here does not change behavior.
  }, [profileForm]);

  useEffect(() => {
    if (successMsg) {
      const timer = setTimeout(() => setSuccessMsg(''), 5000);
      return () => clearTimeout(timer);
    }
  }, [successMsg]);

  const handleSelectChange = (name, value) => {
    profileForm.setFieldsValue({ [name]: value });
    
    if (name === 'parent_category_id') {
      profileForm.setFieldsValue({
        child_category_id: '',
        subchild_category_id: '',
        other_child_category: '',
        other_subchild_category: ''
      });
      setShowOtherCategory(value === 'other');
      setShowOtherChildCategory(false);
      setShowOtherSubCategory(false);
    }
    
    if (name === 'child_category_id') {
      profileForm.setFieldsValue({
        subchild_category_id: '',
        other_subchild_category: ''
      });
      setShowOtherChildCategory(value === 'other');
      setShowOtherSubCategory(false);
    }
    
    if (name === 'subchild_category_id') {
      setShowOtherSubCategory(value === 'other');
    }
  };

  const onProfileFinish = async (values) => {
    try {
      setLoading(true);
      clearMessages();
      
      // Prepare base update data
      let updateData = {
        name: values.name,
        age: values.age,
        contact_no: values.contact_no,
        address: values.address,
        city: values.city,
        pincode: values.pincode,
        state: values.state,
        parent_category_id: values.parent_category_id === 'other' ? null : values.parent_category_id,
        child_category_id: values.child_category_id === 'other' ? null : values.child_category_id,
        subchild_category_id: values.subchild_category_id === 'other' ? null : values.subchild_category_id,
        other_category: values.other_category || null,
        other_child_category: values.other_child_category || null,
        other_subchild_category: values.other_subchild_category || null,
        profile_photo: values.profile_photo,
        identity_doc_type: identityDocType,
        identity_number: values.identity_number
      };

      // Add user type specific fields
      if (userData.user_type === '3rd Party Services') {
        updateData = {
          ...updateData,
          years_of_experience: values.years_of_experience,
          expertise: values.expertise
        };
      } else if (userData.user_type === 'Partner') {
        updateData = {
          ...updateData,
          gender: values.gender,
          aadhaar_number: values.aadhaar_number,
          pan_number: values.pan_number,
          professional_background: values.professional_background,
          industry_experience: values.industry_experience,
          financial_capability: values.financial_capability,
          funding_source: values.funding_source,
          skills: values.skills,
          ownership_preference: values.ownership_preference,
          time_commitment: values.time_commitment,
          past_partnership_experience: values.past_partnership_experience,
          legal_disputes: values.legal_disputes,
          future_vision: values.future_vision,
          business_status: values.business_status,
          business_type: values.business_type
        };
      } else if (userData.user_type === 'Employee') {
        updateData = {
          ...updateData,
          gender: values.gender,
          aadhaar_number: values.aadhaar_number,
          pan_number: values.pan_number,
          permanent_address: values.permanent_address,
          highest_qualification: values.highest_qualification,
          certificate_details: values.certificate_details,
          job_skills: values.job_skills,
          expected_salary: values.expected_salary,
          joining_availability: values.joining_availability,
          notice_period_days: values.notice_period_days,
          emergency_contact_name: values.emergency_contact_name,
          emergency_contact_relation: values.emergency_contact_relation,
          emergency_contact_number: values.emergency_contact_number,
          emergency_contact_address: values.emergency_contact_address,
          same_as_permanent: values.same_as_permanent,
          years_of_experience: values.years_of_experience
        };
      } else if (userData.user_type === 'Business') {
        updateData = {
          ...updateData,
          business_name: values.business_name,
          business_model: values.business_model,
          established_year: values.established_year? values.established_year.format("YYYY"): null,
          reason_for_sale: values.reason_for_sale,
          asking_price: values.asking_price,
          asking_price_unit: values.asking_price_unit,
          annual_turnover: values.annual_turnover,
          annual_turnover_unit: values.annual_turnover_unit,
          net_profit: values.net_profit,
          net_profit_unit: values.net_profit_unit,
          assets_included: values.assets_included,
          liabilities: values.liabilities,
          number_of_employees: values.number_of_employees,
          customer_base: values.customer_base,
          ongoing_projects: values.ongoing_projects,
          franchise_validity: values.franchise_validity,
          business_registration_type: values.business_registration_type,
          registration_number: values.registration_number,
          lease_details: values.lease_details,
          preferred_contact_mode: values.preferred_contact_mode,
          price_negotiable: values.price_negotiable
        };
      }
      
      const response = await api.put('/user/profile', updateData);
      
      setSuccessMsg(response.data.message || 'Profile updated successfully');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      // Refresh user data
      const userResponse = await api.get('/user/about_me');
      setUserData(userResponse.data.data);
      
    } catch (error) {
      console.error('Error updating profile:', error);
      setErrorMsg(error.response?.data?.message || 'Failed to update profile');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally {
      setLoading(false);
    }
  };

  const onPasswordFinish = async (values) => {
    try {
      setLoading(true);
      clearMessages();
      
      const response = await api.put('/user/change-password', {
        current_password: values.currentPassword,
        new_password: values.newPassword,
        confirm_password: values.confirmPassword
      });
      
      setSuccessMsg(response.data.message || 'Password changed successfully');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      passwordForm.resetFields();
    } catch (error) {
      console.error('Error changing password:', error);
      const errorMessage = error.response?.data?.message || 'Failed to change password';
      setErrorMsg(errorMessage);
      
      if (error.response?.data?.errors) {
        const errors = error.response.data.errors;
        passwordForm.setFields(
          Object.keys(errors).map(field => ({
            name: field,
            errors: [errors[field]]
          }))
        );
      }
    } finally {
      setLoading(false);
    }
  };

  // Filter categories based on user type
const filteredCategories = categories.filter(cat => {
  if (!userData?.user_type) return true;

  return cat.user_types
    ?.toLowerCase()
    .split(',')
    .map(s => s.trim())
    .includes(userData.user_type.toLowerCase());
});



  const filteredChildCategories = profileForm.getFieldValue('parent_category_id') && 
    profileForm.getFieldValue('parent_category_id') !== 'other'
    ? childCategories.filter(cat => cat.parent_category_id === profileForm.getFieldValue('parent_category_id'))
    : [];

  const filteredSubchildCategories = profileForm.getFieldValue('child_category_id') && 
    profileForm.getFieldValue('child_category_id') !== 'other'
    ? subchildCategories.filter(cat => cat.child_category_id === profileForm.getFieldValue('child_category_id'))
    : [];

  // Render common fields
  const renderCommonFields = () => (
    <>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item 
            name="name" 
            label="Full Name" 
            rules={[{ required: true, message: 'Please enter your name' }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item 
            name="age" 
            label="Age" 
            rules={[{ required: true, message: 'Please enter your age' }]}
          >
            <Input type="number" min={18} max={100} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item 
            name="contact_no" 
            label="Contact Number" 
            rules={[{ required: true, message: 'Please enter your contact number' }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="state" label="State" rules={[{ required: true }]}>
            <Select
              placeholder="Select State"
              showSearch
              optionFilterProp="children"
              onChange={(value, option) => {
                const stateObj = statesList.find(s => s.name === value);
                if (stateObj) {
                  handleStateSelect(stateObj.iso2, value);
                }
              }}
            >
              {statesList.map(state => (
                <Option key={state.iso2} value={state.name}>{state.name}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="city" label="City" rules={[{ required: true }]}>
            <Select
              placeholder="Select City"
              showSearch
              optionFilterProp="children"
              disabled={!profileForm.getFieldValue('state')}
            >
              {citiesList.map(city => (
                <Option key={city.id} value={city.name}>{city.name}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item 
            name="pincode" 
            label="Pincode" 
            rules={[{ required: true, message: 'Please enter your pincode' }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item 
        name="address" 
        label="Current Address" 
        rules={[{ required: true, message: 'Please enter your address' }]}
      >
        <TextArea rows={3} />
      </Form.Item>
    </>
  );

  // Render category fields
  const renderCategoryFields = () => (
    <>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="parent_category_id" label="Category">
            <Select
              placeholder="Select Category"
              onChange={(value) => handleSelectChange('parent_category_id', value)}
            >
              {filteredCategories.map(cat => (
                <Option key={cat.id} value={cat.id}>{cat.name}</Option>
              ))}
              <Option key="other" value="other">Other</Option>
            </Select>
          </Form.Item>
        </Col>

        {showOtherCategory && (
          <Col span={8}>
            <Form.Item name="other_category" label="Other Category" rules={[{ required: true }]}>
              <Input placeholder="Enter your other category" />
            </Form.Item>
          </Col>
        )}

        {profileForm.getFieldValue('parent_category_id') && 
         profileForm.getFieldValue('parent_category_id') !== 'other' && (
          <>
            <Col span={8}>
              <Form.Item name="child_category_id" label="Sub Category">
                <Select
                  placeholder="Select Sub Category"
                  onChange={(value) => handleSelectChange('child_category_id', value)}
                >
                  {filteredChildCategories.map(cat => (
                    <Option key={cat.id} value={cat.id}>{cat.name}</Option>
                  ))}
                  <Option key="other" value="other">Other</Option>
                </Select>
              </Form.Item>
            </Col>

            {showOtherChildCategory && (
              <Col span={8}>
                <Form.Item name="other_child_category" label="Other Sub Category">
                  <Input placeholder="Enter your other sub category" />
                </Form.Item>
              </Col>
            )}

            {profileForm.getFieldValue('child_category_id') && 
             profileForm.getFieldValue('child_category_id') !== 'other' && (
              <>
                <Col span={8}>
                  <Form.Item name="subchild_category_id" label="Child Sub Category">
                    <Select
                      placeholder="Select Child Sub Category"
                      onChange={(value) => handleSelectChange('subchild_category_id', value)}
                    >
                      {filteredSubchildCategories.map(cat => (
                        <Option key={cat.id} value={cat.id}>{cat.name}</Option>
                      ))}
                      <Option key="other" value="other">Other</Option>
                    </Select>
                  </Form.Item>
                </Col>

                {showOtherSubCategory && (
                  <Col span={8}>
                    <Form.Item name="other_subchild_category" label="Other Child Sub Category">
                      <Input placeholder="Enter your other child sub category" />
                    </Form.Item>
                  </Col>
                )}
              </>
            )}
          </>
        )}
      </Row>
    </>
  );

  // Render 3rd Party Services form
  const renderThirdPartyForm = () => (
    <>
      {renderCommonFields()}
      {renderCategoryFields()}
      
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="years_of_experience" label="Years of Experience">
            <Input type="number" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="expertise" label="Expertise (if any)">
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </>
  );

  // Render Partner form
  const renderPartnerForm = () => (
    <>
      {renderCommonFields()}
      
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="business_type" label="Partner Match">
            <Select placeholder="Select Partner Match">
              {businessTypeOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="gender" label="Gender">
            <Select placeholder="Select Gender">
              {genderOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      
      {renderCategoryFields()}
      
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="identity_doc_type" label="Identity Document Type">
            <Select
              placeholder="Select Document Type"
              onChange={(value) => setIdentityDocType(value)}
            >
              {identityDocOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        {identityDocType && (
          <Col span={12}>
            <Form.Item name="identity_number" label={
              identityDocType === 'aadhaar' ? 'Aadhaar Number' :
              identityDocType === 'pan' ? 'PAN Number' :
              identityDocType === 'voter_id' ? 'Voter ID Number' : 'Passport Number'
            }>
              <Input placeholder={
                identityDocType === 'aadhaar' ? 'Aadhaar Number' :
                identityDocType === 'pan' ? 'PAN Number' :
                identityDocType === 'voter_id' ? 'Voter ID Number' : 'Passport Number'
              } />
            </Form.Item>
          </Col>
        )}
      </Row>
      
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="professional_background" label="Current Occupation/Business">
            <Select placeholder="Select Current Occupation/Business">
              {professionalBackgroundOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="industry_experience" label="Industry Experience (years)">
            <Input type="number" />
          </Form.Item>
        </Col>
      </Row>
      
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="financial_capability" label="Financial Capability">
            <Select placeholder="Select Financial Capability">
              {financialCapabilityOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="funding_source" label="Funding Source">
            <Select placeholder="Select Funding Source">
              {fundingSourceOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      
      <Form.Item name="skills" label="Skills & Expertise">
        <TextArea rows={3} />
      </Form.Item>
      
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="ownership_preference" label="Ownership Preference (%)">
            <Input type="number" min={0} max={100} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="time_commitment" label="Time Commitment">
            <Select placeholder="Select Time Commitment">
              {timeCommitmentOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="business_status" label="Business Status">
            <Select placeholder="Select Business Status">
              {businessStatusOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="past_partnership_experience" label="Past Partnership Experience">
            <Select placeholder="Select Option">
              <Option value="yes">Yes</Option>
              <Option value="no">No</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="legal_disputes" label="Any Legal Disputes">
            <Select placeholder="Select Option">
              <Option value="yes">Yes</Option>
              <Option value="no">No</Option>
              <Option value="Prefer not to disclose">Prefer not to disclose</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      
      <Form.Item name="future_vision" label="Select Business Vision">
        <Select placeholder="Future Business Vision">
          {futureVisionOptions.map(option => (
            <Option key={option.value} value={option.value}>{option.label}</Option>
          ))}
        </Select>
      </Form.Item>
    </>
  );

  // Render Skilled Employee form
  const renderEmployeeForm = () => (
    <>
      {renderCommonFields()}
      
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="gender" label="Gender">
            <Select placeholder="Select Gender">
              {genderOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="permanent_address" label="Permanent Address">
            <Input />
          </Form.Item>
        </Col>
      </Row>
      
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="aadhaar_number" label="Aadhaar Number">
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="pan_number" label="PAN Number">
            <Input />
          </Form.Item>
        </Col>
      </Row>
      
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="highest_qualification" label="Highest Qualification">
            <Select placeholder="Select Qualification">
              {qualificationOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="certificate_details" label="Certificate (if any) - otherwise NA">
            <Input placeholder="Certificate Details" />
          </Form.Item>
        </Col>
      </Row>
      
      {renderCategoryFields()}
      
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="job_skills" label="Skills / Expertise">
            <TextArea rows={3} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="years_of_experience" label="Years of Experience">
            <Input type="number" />
          </Form.Item>
        </Col>
      </Row>
      
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="expected_salary" label="Expected Salary">
            <Input type="number" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="joining_availability" label="Joining Availability">
            <Select placeholder="Select Availability">
              {joiningAvailabilityOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      
      {profileForm.getFieldValue('joining_availability') === "Notice period" && (
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="notice_period_days" label="Notice Period (Days)">
              <Input type="number" min="1" />
            </Form.Item>
          </Col>
        </Row>
      )}
      
      <Divider>Emergency Contact</Divider>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="emergency_contact_name" label="Name">
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="emergency_contact_relation" label="Relation">
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="emergency_contact_number" label="Mobile Number">
            <Input />
          </Form.Item>
        </Col>
      </Row>
      
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="same_as_permanent" label="Is Emergency Address Same as Permanent?">
            <Select placeholder="Select Option">
              {sameAsPermanentOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        
        {profileForm.getFieldValue('same_as_permanent') === "no" && (
          <Col span={12}>
            <Form.Item name="emergency_contact_address" label="Emergency Address">
              <TextArea rows={3} />
            </Form.Item>
          </Col>
        )}
      </Row>
    </>
  );

  // Render Business for Sale form
  const renderBusinessForm = () => (
    <>
      {renderCommonFields()}
      
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item 
            name="business_name" 
            label="Business Name" 
            rules={[{ required: true, message: 'Please enter business name' }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      
      {renderCategoryFields()}
      
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="business_model" label="Business Model">
            <Select placeholder="Select Business Model">
              {businessModelOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
       <Form.Item name="established_year" label="Established Year">
        <DatePicker
          picker="year"
          placeholder="Select Year"
          className="w-100"
          format="YYYY" 
        />
      </Form.Item>
 
        </Col>
      </Row>
      
      <Form.Item name="reason_for_sale" label="Reason for Sale">
        <TextArea rows={3} />
      </Form.Item>
      
      <Row gutter={16}>
        <Col span={8}>
            <Form.Item name="asking_price" label="Asking Price">
            <Input type="asking_price" />
          </Form.Item>
          <Form.Item name="asking_price_unit" label="Asking Price Unit">
          
         
            <Select placeholder="Select Unit">
              {priceUnitOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
             <Form.Item name="annual_turnover" label="Annual Turnover">
            <Input type="annual_turnover" />
          </Form.Item>
          <Form.Item name="annual_turnover_unit" label="Annual Turnover Unit">
            <Select placeholder="Select Unit">
              {priceUnitOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
             <Form.Item name="net_profit" label="Net Profit">
            <Input type="net_profit" />
          </Form.Item>
          <Form.Item name="net_profit_unit" label="Net Profit Unit">
            <Select placeholder="Select Unit">
              {priceUnitOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="assets_included" label="Assets Included">
            <TextArea rows={3} placeholder="Machinery, Furniture, Inventory, Office Setup, etc." />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="liabilities" label="Liabilities">
            <TextArea rows={3} placeholder="If any otherwise N/A" />
          </Form.Item>
        </Col>
      </Row>
      
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="number_of_employees" label="Number of Employees">
            <Input type="number" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="customer_base" label="Customer Base / Client Contracts">
            <Select placeholder="Select Option">
              {customerBaseOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="ongoing_projects" label="Ongoing Projects">
            <Input placeholder="Ongoing Projects (if any)" />
          </Form.Item>
        </Col>
      </Row>
      
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="franchise_validity" label="Franchise/License Validity">
            <Input placeholder="If franchise business" />
          </Form.Item>
        </Col>
      </Row>
      
      <Divider>Legal / Document Info</Divider>
      
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="business_registration_type" label="Business Registration Type">
            <Select placeholder="Select Registration Type">
              {registrationTypeOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="registration_number" label="Registration Number">
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="lease_details" label="Lease/Rent Agreement Details">
            <Input placeholder="If applicable" />
          </Form.Item>
        </Col>
      </Row>
      
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="preferred_contact_mode" label="Preferred Mode of Contact">
            <Select placeholder="Select Contact Mode">
              {contactModeOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="price_negotiable" label="Negotiable or Fixed Price">
            <Select placeholder="Select Option">
              {priceOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </>
  );

  // Render form based on user type
  const renderFormByUserType = () => {
    if (!userData) return null;
    
    switch(userData.user_type) {
      case '3rd Party Services':
        return renderThirdPartyForm();
      case 'Partner':
        return renderPartnerForm();
      case 'Employee':
        return renderEmployeeForm();
      case 'Business':
        return renderBusinessForm();
      default:
        return renderCommonFields();
    }
  };

  return (
    <div className="profile-settings-container" style={{ padding: '20px' }}>
      <h2>Profile Settings</h2>
      <Divider />
      
      {successMsg && (
        <Alert
          message={successMsg}
          type="success"
          showIcon
          closable
          onClose={() => setSuccessMsg('')}
          style={{ marginBottom: 16 }}
        />
      )}
      
      {errorMsg && (
        <Alert
          message={errorMsg}
          type="error"
          showIcon
          closable
          onClose={() => setErrorMsg('')}
          style={{ marginBottom: 16 }}
        />
      )}
      
      <Tabs defaultActiveKey="profile">
        <TabPane tab="Profile Information" key="profile">
          {isLoadingUserData ? (
            <div style={{ textAlign: 'center', padding: '24px' }}>
              <Spin size="large" />
              <p>Loading profile data...</p>
            </div>
          ) : (
            <Form
              form={profileForm}
              onFinish={onProfileFinish}
              layout="vertical"
            >
              <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={24}>
                  <Form.Item name="profile_photo" hidden>
                    <Input />
                  </Form.Item>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    <Avatar 
                      size={64} 
                      src={
                        fileList.length > 0 && fileList[0].url ? 
                        fileList[0].url : 
                        userData?.profile_photo ? 
                        `${PROFILE_PHOTO_BASE_URL}${userData.profile_photo}` : 
                        null
                      }
                    >
                      {userData?.name?.charAt(0)?.toUpperCase()}
                    </Avatar>
                    <Upload {...uploadProps} maxCount={1}>
                      <Button icon={<UploadOutlined />} loading={uploading}>
                        {uploading ? 'Uploading...' : 'Change Profile Photo'}
                      </Button>
                    </Upload>
                  </div>
                  <div style={{ marginTop: 8, color: '#666', fontSize: '12px' }}>
                    Supported formats: JPG, PNG, GIF (Max: 2MB)
                  </div>
                </Col>
              </Row>

       <Alert
  message={`User Type: ${
    {
      Partner: 'Strategic Partner',
      Business: 'Business Opportunities - Sell & Buy',
      '3rd Party Services': 'Professional Services',
      Employee: 'Talent & Workforce',
    }[userData?.user_type] || userData?.user_type
  }`}
  type="info"
  showIcon
  style={{ marginBottom: 16 }}
/>

              {renderFormByUserType()}

              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Update Profile
                </Button>
              </Form.Item>
            </Form>
          )}
        </TabPane>

        <TabPane tab="Change Password" key="password">
          <Form
            form={passwordForm}
            onFinish={onPasswordFinish}
            layout="vertical"
            validateTrigger={['onChange', 'onSubmit']}
          >
            <Form.Item
              name="currentPassword"
              label="Current Password"
              rules={[
                { 
                  required: true, 
                  message: 'Please enter your current password' 
                }
              ]}
              hasFeedback
            >
              <Input.Password placeholder="Enter current password" />
            </Form.Item>

            <Form.Item
              name="newPassword"
              label="New Password"
              rules={[
                { 
                  required: true, 
                  message: 'Please enter new password' 
                },
                { 
                  min: 6, 
                  message: 'Password must be at least 6 characters' 
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (value && getFieldValue('currentPassword') === value) {
                      return Promise.reject('New password must be different from current password');
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              hasFeedback
            >
              <Input.Password placeholder="Enter new password" />
            </Form.Item>

            <Form.Item
              name="confirmPassword"
              label="Confirm New Password"
              dependencies={['newPassword']}
              rules={[
                {  
                  required: true, 
                  message: 'Please confirm your new password' 
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject('The two passwords do not match!');
                  },
                }),
              ]}
              hasFeedback
            >
              <Input.Password placeholder="Confirm new password" />
            </Form.Item>

            <Form.Item>
              <Button 
                type="primary" 
                htmlType="submit" 
                loading={loading}
                disabled={passwordForm.getFieldsError().filter(({ errors }) => errors.length).length > 0}
              >
                Change Password
              </Button>
            </Form.Item>
          </Form>
        </TabPane>
      </Tabs>
    </div>
  );
};

export default ProfileSettings;